<template>
  <div class="">
    <div class="vld-parent">
      <loading
        :active.sync="loading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="false"
        :height="25"
        :width="25"
      ></loading>
      <div class="filters my-1">
        <span class="filter-item" v-if="filterView.q"
          >{{ filterView.q }}
          <span class="filter-clear"
            ><i
              class="fas fa-times"
              @click="
                () => {
                  $store.dispatch('setQueryFilter', null);
                }
              "
            ></i
          ></span>
        </span>
        <span class="filter-item" v-if="filterView.category">
          {{ filterView.category }}
          <span class="filter-clear"
            ><i
              class="fas fa-times"
              @click="
                () => {
                  $store.dispatch('setCategoryFilter', null);
                }
              "
            ></i
          ></span>
        </span>
      </div>
      <div class="row">
        <div
          class="col-md-3"
          v-for="product in products.data.filter((prod) =>
            prod.name.toLowerCase().includes(searchTerm.toLowerCase())
          )"
          :key="product.id"
        >
          <products-component :product="product"></products-component>
        </div>
        <div
          class="col section text-center my-3"
          v-if="products.data.length === 0"
        >
          {{ noProductLabel }}
        </div>
      </div>

      <b-pagination
        v-if="products.pagination.lastPage > 1"
        v-model="filter.page"
        :total-rows="products.pagination.total"
        :per-page="products.pagination.perPage"
        class="mt-4"
        align="center"
        @input="fetchProducts"
        pills
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import ProductsComponent from "@/views/products_list/ProductItem";
import { getByTitle } from "../../filters";
import { mapGetters } from "vuex";

export default {
  name: "products-list-component",

  components: {
    "products-component": ProductsComponent,
  },

   metaInfo:{
     title:"فست فود",
      //meta: [{ name: "description", content: "My page meta description" }],
   },

    

  data() {
    return {
      loading: false,
      id: "",
      noProductLabel: "محصولی یافت نشد!",
      productsFiltered: [],

      // query: {
      //   q: undefined,
      //   category: undefined,
      //   brand: undefined,
      //   page:
      //     this.products && this.products.pagination.page
      //       ? this.products.pagination.page
      //       : 1,
      //   limit:
      //     this.products && this.products.pagination.perPage
      //       ? this.products.pagination.perPage
      //       : 20,
      // },

      unwatch: null,
    };
  },

  computed: {
    ...mapGetters({
      products: "products",
      searchTerm: "searchTerm",
      filter: "filter",
      filterView: "filterView",
    }),
  },

  beforeDestroy() {
    // Will this unwatch and prevent memory leaks?
    //this.$store.watch((state, getters) => getters.filter)
    this.unwatch();
  },

  created() {
    let $this = this;
    this.unwatch = this.$store.watch(
      (state, getters) => getters.filter,
      function (newValue) {
        $this.fetchProducts();
      },
      {
        deep: true, //add this if u need to watch object properties change etc.
      }
    );
  },

  mounted() {
    this.fetchProducts();
  },

  methods: {
    fetchProducts() {
      console.log("fetchProducts");
      this.loading = true;
      this.updateQueryParameters();
      this.$store.dispatch("fetchProducts", this.filter).then(() => {
        this.loading = false;
      });
    },

    updateQueryParameters() {
      if (this.filter.page > 1) {
        // eslint-disable-next-line
        this.$router.replace({ query: { page: this.filter.page } });
      } else if (this.filter.page === 1) {
        // eslint-disable-next-line
        this.$router.replace({ query: {} }).then();
      }
    },

    onCancel() {},
  },
};
</script>

<style lang="scss" scoped>
.card {
  margin: 10px;
}
.filter-item {
  display: inline-block;
  border-radius: 15px;
  border: 1px solid #ccc;
  padding: 5px;
  box-shadow: 0 0 2px #ccc;
  margin: 5px;
  padding-left: 20px;
}
.filter-clear {
  padding: 0 4px;
  color: #777;
  position: absolute;
  top: 13px;
}
</style>
